import { Injectable, inject } from '@angular/core';
import { Capacitor } from '@capacitor/core';
import { SafeArea, SafeAreaInsets } from 'capacitor-plugin-safe-area';
import { STYLE_VALUES_PASSED_VIA_HTML } from 'src/util/constants';
import { DeviceService } from './device.service';

// todo - probably rename this service to some like native margins or so
@Injectable({
  providedIn: 'root'
})
export class NativeSafeZoneService {
  private deviceService = inject(DeviceService);

  public paddings = {
    top: 0,
    bottom: 0,
    navbarHeight: 0,
  }

  public constructor() {
    if(this.deviceService.isNativePlatform) {
      const styles = getComputedStyle(document.documentElement);
      const value = styles.getPropertyValue(STYLE_VALUES_PASSED_VIA_HTML.BOTTOM_NAVBAR_HEIGHT);
      this.paddings.navbarHeight = parseFloat(value);
      SafeArea.getSafeAreaInsets().then((insets) => {
        this.setValues(insets);
      });
    } else {
      this.setValues({
        insets: {
          top: 0,
          bottom: 0,
          left: 0,
          right: 0,
        }
      });
    }
  }

  private setValues(insets: SafeAreaInsets) {
    this.paddings.top = insets.insets.top;
    this.paddings.bottom = insets.insets.bottom;
    document.documentElement.style.setProperty(STYLE_VALUES_PASSED_VIA_HTML.TOP_SAFEZONE_HEIGHT, `${this.paddings.top}px`)
    document.documentElement.style.setProperty(STYLE_VALUES_PASSED_VIA_HTML.BOTTOM_SAFEZONE_HEIGHT, `${this.paddings.bottom}px`)
    // Android system navigation takes its own space at the bottom (iOS home indicator only overlays the page),
    // so the bottom navbar and everything placed above it moves up by its height
    if (Capacitor.getPlatform() === 'android') {
      this.paddings.navbarHeight += this.paddings.bottom;
      document.documentElement.style.setProperty(STYLE_VALUES_PASSED_VIA_HTML.BOTTOM_NAVBAR_HEIGHT, `${this.paddings.navbarHeight}px`)
      document.documentElement.style.setProperty(STYLE_VALUES_PASSED_VIA_HTML.ANDROID_NAVIGATION_HEIGHT, `${this.paddings.bottom}px`)
    }
  }
}
